export const STEPS = [
  {
    label: "Personal Information",
    path: "/register/personal-information",
    key: "PersonalInformation",
  },
  {
    label: "Email Verification",
    path: "/register/email-verification",
    key: "EmailVerification",
    description:
      "Please verify your email before proceeding and be sure to check your spam folder if you don't see the email in your inbox. if you'd like for the email to be resent, please click the resend button.",
  },
  {
    label: "Disclaimer",
    path: "/register/disclaimer",
    key: "Disclaimer",
  },
  {
    label: "Upload KYC",
    path: "/register/upload-kyc",
    key: "UploadKYC",
    description: 
      "This requires documents for verufication of Lever 1 which allow to withdraw 5BTC Monthly. For move withdraws you need to complate Level 2 verification procedure.",
  },
  {
    label: "Link Account to a Theta Wallet Address using MetaMask",
    path: "/register/link-wallet",
    key: "LinkWallet",
  },
  {
    label: "Account Summary",
    path: "/register/account-summary",
    key: "CaseStatus",
  },
];

export const STEPS_DATA = {
  personalInformation: {
    first_name: "",
    last_name: "",
    mobile: "",
    street: "",
    city: "",
    zip_code: undefined,
    country: "",
    invitation_code: "",
    email: "",
    password: "",
    password_confirmation: "",
  },
  emailVerification: {
    email: "",
  },
  disclaimer: {
    terms: false,
  },
  uploadKYC: {
    kyc_file: null,
    type: "",
  },
  linkWallet: {
    wallet_address: "",
    status: 0,
    message: "",
  },
  caseStatus: {
    case_status: "",
  },
}